/**
 * Created by theodora on 6/12/14.
 */

'use strict';

const { getUserId } = require('dibs-cookie-jar');
const authModalLoader = require('./AuthModalLoader').default;
const qs = require('querystring');

const authModals = [
    authModalLoader.constants.LOGIN,
    authModalLoader.constants.REGISTER,
    authModalLoader.constants.RESET_PASSWORD,
    authModalLoader.constants.RESET_INVALID
];

/**
 *
 * @param uri
 * @returns {string}
 */
const getRedirectDestination = function () {
    const queryKey = qs.parse(window.location.search.substr(1));
    let dest = queryKey.ep ? decodeURIComponent(queryKey.ep) : null;
    if (dest && dest.indexOf('//') > -1) {
        // id ep contains '//' then redirect to current page
        // if phishing is happening, just redirect to the homepage (uri.path = '/')
        dest = window.location.href;
    }

    return dest;
};

module.exports = {

    /**
     * Changed window object to parameter for easier testing
     * @param {object} win Mock window object
     * @param {object} uri Mock object mainly for testing
     */
    init: function checkForAuthModal() {
        const destination = getRedirectDestination();
        let action = qs.parse(window.location.search.substr(1)).modal || '';
        const gaAction = action.replace('_', ' ');
        action = action.replace('_', '-');
        const authOptions = {
            action: action,
            ga: {
                label: gaAction + ' query param - address bar',
                value: window.scrollY ? 1 : 0
            }
        };

        if (action) {
            if (authModals.indexOf(action) > -1) {
                // Need to make sure we have fresh user state
                // and don't get into infinite redirect loops
                if (getUserId(document.cookie) && destination) {
                    window.location.href = destination;
                } else {
                    authModalLoader.show(authOptions).then(function (authResponse) {
                        if (destination && !authResponse.err) {
                            window.location.href = destination;
                        }
                    });
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/AuthModalCheck.js